export default {
  sureToDeleteVoiceMail: 'Are you sure you want to delete this voicemail?',
  sureToDeleteFax: 'Are you sure you want to delete this fax?',
  doNotAskAgain: "Don't ask me again",
} as const;
